import React, { FC } from 'react';
import styled from 'styled-components';

interface Props {
    rounded?: boolean;
    icon: React.ReactNode;
}

const Icon: FC<React.PropsWithChildren<Props>> = ({ icon, rounded, ...rest }) => (
    <IconWrapper rounded={rounded} {...rest}>
        {icon}
    </IconWrapper>
);

export default Icon;

const IconWrapper = styled.div<{ rounded?: boolean }>`
    height: 4rem;
    width: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ rounded, theme }) =>
        rounded &&
        `
    border-radius: 50%;
    border: .1rem solid ${theme.colors.primary['80']};
    `}

    svg {
        height: 1.6rem;
        width: 1.6rem;
        color: ${({ theme }) => theme.colors.neutral['0']};
    }

    &:hover {
        background-color: ${({ theme }) => theme.colors.neutral['0']};

        svg {
            color: ${({ theme }) => theme.colors.primary['60']};
        }
    }
`;
